import { MethodRequest } from "../constants";
import FormData from "form-data";

class APIWrapper {
	public async request<T>(url: string = "", options: RequestInit = {}): Promise<T> {
		const defaultHeaders = {
			Authorization: `Bearer ${localStorage.getItem(API.nameToken)}`,
			"x-requested-with": "XMLHttpRequest",
			"x-customheader": API.language,
		};

		const headers = {
			...defaultHeaders,
			...(options.headers || {}),
		};

		const requestOptions: RequestInit = {
			method: MethodRequest.Get,
			...options,
			headers,
		};

		const result = await fetch(`${this.getCorePath}${url}`, requestOptions);
		const response = await result.json();

		if (!result.ok) {
			throw response;
		}

		return response;
	}

	public getFormData(data: any, notEmpty = true): BodyInit {
		const formData = new FormData();

		Object.keys(data).forEach((key) => {
			if (data[key] || !notEmpty) {
				if (Array.isArray(data[key])) {
					data[key].forEach((item: any) => {
						if (item instanceof File) {
							formData.append(`${key}[]`, item);
						} else {
							formData.append(`${key}[]`, JSON.stringify(item));
						}
					});
				} else if (data[key] instanceof File) {
					formData.append(key, data[key]);
				} else if (typeof data[key] === "object") {
					formData.append(key, JSON.stringify(data[key]));
				} else if (typeof data[key] === "boolean") {
					formData.append(key, +data[key]);
				} else {
					formData.append(key, data[key]);
				}
			} else {
				console.log("empty data[key]", key, data[key]);
			}
		});

		// @ts-ignore
		return formData;
	}

	public async get<T>(url: string, options: RequestInit = {}): Promise<T> {
		return this.request<T>(url, {
			...options,
			method: MethodRequest.Get,
		});
	}

	public async post<T>(url: string, data?: unknown, options: RequestInit = {}): Promise<T> {
		return this.request<T>(url, {
			...options,
			method: MethodRequest.Post,
			headers: {
				"Content-Type": "application/json",
				...(options.headers || {}),
			},
			body: data ? JSON.stringify(data) : undefined,
		});
	}

	public set saveLanguage(value: string) {
		localStorage.setItem("LANG", value);
	}

	public get language(): string {
		return localStorage.getItem("LANG") || "EN";
	}

	public get nameToken(): string {
		return process.env.REACT_APP_NAME_TOKEN || "";
	}

	public set saveToken(value: string) {
		localStorage.setItem(this.nameToken, value);
	}

	public removeToken() {
		localStorage.removeItem(this.nameToken);
	}

	public get getCorePath(): string {
		return process.env.REACT_APP_CORE_API_URL || "/not-set-api-path/";
	}

	public get getFilesPath(): string {
		return process.env.REACT_APP_CORE_FILES || "/not-set-files-path/";
	}

	public get wsPath(): string {
		return process.env.REACT_APP_WEBSOCKET_URL || "ws://not-set";
	}

	public get stripeKey(): string {
		return process.env.REACT_APP_STRIPE_KEY || "";
	}

	public get jwtToken() {
		return localStorage.getItem(API.nameToken) || "";
	}
}

export const API = new APIWrapper();
